import { HttpInterceptorFn } from '@angular/common/http';
import {
  resolveProductHeaderValue,
  resolveSiteHeaderValue
} from '../../shared/utils/portal-hosts';

const SITE_HEADER_NAME = 'site';
/** WI 35087: which of the two products sharing this deployment the request is for. */
const PRODUCT_HEADER_NAME = 'product';

export const siteHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  // Only attach the `site` header for calls targeting our own backend.
  // Sending it on cross-origin requests (e.g. WordPress at qne.cloud) makes
  // the browser issue a CORS preflight asking for the `site` header, which
  // those servers don't allow → request fails with net::ERR_FAILED.
  const isApiCall = req.url.includes('api/');
  if (!isApiCall) {
    return next(req);
  }

  // Hostname-based so shared slots (account-test + n3-test) send the right site.
  const headers: Record<string, string> = {
    [SITE_HEADER_NAME]: resolveSiteHeaderValue()
  };

  // Only known products send this; other portals keep their `site` identity.
  const product = resolveProductHeaderValue();
  if (product) {
    headers[PRODUCT_HEADER_NAME] = product;
  }

  return next(req.clone({ setHeaders: headers }));
};
